module.exports = __webpack_public_path__ + "img/6.ab538c42.jpg";